import * as React from 'react';
import styled from 'styled-components';

import LeftQuote from '../../ui/quotes/LeftQuote';
import RightQuote from '../../ui/quotes/RightQuote';

const StyledArticleQuote = styled.div`
  position: relative;
  width: 100%;
  max-width: 30rem;
  margin: 0 auto;
  padding: 4em 0;

  h3 {
    padding: 0 1em;
    text-align: center;
    margin-bottom: 0;
  }
  .right-quote {
    float: right;
  }
`;

export const ArticleQuote: React.FC<{ quote: string }> = ({ quote }) => {
  return (
    <StyledArticleQuote>
      <LeftQuote className="left-quote" />
      <h3>{quote}</h3>
      <RightQuote className="right-quote" />
    </StyledArticleQuote>
  );
};
